import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InsideDisableComponent } from '../inside-disable/inside-disable.component';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: true,
    imports: [NgIf, ProgressSpinnerModule, NgFor, InsideDisableComponent]
})
export class LoadingComponent {

    @Input() isLoading: boolean;
    @Input() isDisabled = false;
    @Input() messages: string[] = [];
    currentMessageIndex = 0;

    constructor() {
  	    this.cycleMessages();
    }

    cycleMessages(): void {
        setInterval(() => {
            this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
        }, 5000);
    }
}
